import { FC, Fragment, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// Hooks
import useToggle from 'hooks/useToggle';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch } from 'hooks/useStore';
// Async
import { getQuizEvents } from 'store/quizEvent/quizEventAsync';
// Actions
import { setInitialField } from 'store/quizEvent/quizEventSlice';
// Components
import { Toolbar } from 'components/Toolbar';
import { Button } from 'components/Buttons';
import QuizEventsList from './QuizEventsList';
import QuizEventDialog from 'dialogs/QuizEvent.dialog';

const QuizEventsPage:FC = () => {
  const { t } = useTranslation();

  const { quizId } = useParams<{ quizId: string }>();

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getQuizEvents(quizId));

    return () => {
      dispatch(setInitialField('quizEvents'));
    }
    // eslint-disable-next-line
  }, []);

  const { open, toggle } = useToggle();

  return (
    <Fragment>
      <div className="container max-w-screen-desktop flex-grow py-4 overflow-y-auto">
        <Toolbar className="items-center gap-2" title={t('pages.quizEvents.title')}>
          <Button variant="contained" onClick={toggle}>
            {t('buttons.createEvent')}
          </Button>
        </Toolbar>
        <QuizEventsList />
      </div>
      {open ? (
        <QuizEventDialog open={open} onClose={toggle} quizId={quizId} />
      ) : null}
    </Fragment>
  )
}

export default QuizEventsPage;
